import styled from 'styled-components';
import { breakpoints } from 'theme';

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
  padding: 40px 20px;
`;

export const EmptyStateIcon = styled.div`
  font-size: 62px;
  margin-bottom: 16px;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.color.pickledBluewood};
  margin: 0 0 6px 0;
  letter-spacing: -0.255px;

  @media ${breakpoints.downMd} {
    font-size: 16px;
    line-height: 1.2;
  }

  @media ${breakpoints.downSmPlus} {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }
`;

export const EmptyStateDescription = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.baliHai};
  margin: 0 0 24px 0;
  max-width: 280px;
  white-space: pre-wrap;
  line-break: normal;
  text-align: center;
  position: relative;
`;

export const EmptyStateButtonWrapper = styled.div`
  position: absolute;
  bottom: -84px;
  left: 50%;
  width: max-content;
  transform: translate(-50%, -50%);
`;
